import { create } from "zustand";
import type { OAuthCredential } from "firebase/auth";

interface AuthState {
  mode: "signin" | "create";
  emailInput: string;
  magicLinkSent: boolean;
  magicLinkEmail: string;
  linkProviderEmail: string | null;
  linkProviderCredential: OAuthCredential | null;

  setMode: (mode: "signin" | "create") => void;
  setEmailInput: (email: string) => void;
  setMagicLinkSent: (email: string) => void;
  setLinkProviderChallenge: (email: string, credential: OAuthCredential) => void;
  clearLinkProviderChallenge: () => void;
  resetMagicLink: () => void;
  reset: () => void;
}

const defaultAuthState = {
  mode: "signin" as const,
  emailInput: "",
  magicLinkSent: false,
  magicLinkEmail: "",
  linkProviderEmail: null,
  linkProviderCredential: null,
};

export const useAuthStore = create<AuthState>((set) => ({
  ...defaultAuthState,

  setMode: (mode) => set({ mode }),

  setEmailInput: (email) => set({ emailInput: email }),

  setMagicLinkSent: (email) =>
    set({ magicLinkSent: true, magicLinkEmail: email }),

  setLinkProviderChallenge: (email, credential) =>
    set({ linkProviderEmail: email, linkProviderCredential: credential }),

  clearLinkProviderChallenge: () =>
    set({ linkProviderEmail: null, linkProviderCredential: null }),

  resetMagicLink: () =>
    set({ magicLinkSent: false, magicLinkEmail: "", emailInput: "" }),

  reset: () => set({ ...defaultAuthState }),
}));
